import { isWeb } from "@tamagui/constants";
import { getConfig } from "../config";
import { expandStyle } from "./expandStyle";
import { normalizeShadow } from "./normalizeShadow";
import { normalizeValueWithProperty } from "./normalizeValueWithProperty";
import { pseudoDescriptors } from "./pseudoDescriptors";
let shorthands = null;
function expandStyles(style, config = getConfig()) {
  const res = {};
  for (let key in style) {
    shorthands = shorthands || (config ? config.shorthands : null);
    if (shorthands) {
      key = shorthands[key] || key;
    }
    if (key in pseudoDescriptors) {
      res[key] = expandStyles(style[key]);
      continue;
    }
    const val = normalizeValueWithProperty(style[key], key);
    const out = expandStyle(key, val);
    if (out) {
      Object.assign(res, Object.fromEntries(out));
    } else {
      res[key] = val;
    }
  }
  fixStyles(res);
  return res;
}
function fixStyles(style) {
  if (style.shadowRadius || style.shadowColor || style.shadowOpacity || style.shadowOffset) {
    Object.assign(style, normalizeShadow(style));
  }
  for (const key in borderDefaults) {
    if (key in style && !style[borderDefaults[key]]) {
      style[borderDefaults[key]] = "solid";
    }
  }
}
const nativeStyle = isWeb ? null : "borderStyle";
const borderDefaults = {
  borderWidth: "borderStyle",
  borderBottomWidth: nativeStyle || "borderBottomStyle",
  borderTopWidth: nativeStyle || "borderTopStyle",
  borderLeftWidth: nativeStyle || "borderLeftStyle",
  borderRightWidth: nativeStyle || "borderRightStyle"
};
export {
  expandStyles,
  fixStyles
};
//# sourceMappingURL=expandStyles.js.map
